import { apiSlice } from './apiSlice.js'
import { ORDERS_URL } from '../constants.js'


export const ordersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createOrder: builder.mutation({
      query: (order) => ({
        url: ORDERS_URL,
        method: "POST",
        body: { ...order },
      }),
      transformResponse: (response) => {
        console.log("Transformed Response:", response); // ✅ Debug response
        return response;
      },
    }),
    completeOrderPurchase: builder.mutation({
      query: (orderId) => ({
        url: `${ORDERS_URL}/${orderId}/complete-purchase`,
        method: "PUT",
      }),
    }),
    getOrderDetails: builder.query({
      query: ({ orderId, includeCreators = false }) => ({
        url: `${ORDERS_URL}/${orderId}?includeCreators=${includeCreators}`,
      }),
      keepUnusedDataFor: 5,
    }),
    getOrderInvoice: builder.query({
      query: (orderId) => ({
        url: `${ORDERS_URL}/${orderId}/invoice`,
      }),
      keepUnusedDataFor: 5,
    }),
    payOrder: builder.mutation({
      query: ({ orderId, details }) => ({
        url: `${ORDERS_URL}/${orderId}/pay`,
        method: "PUT",
        body: details,
      }),
    }),
    updateOrderPaymentMethod: builder.mutation({
      query: ({ orderId, paymentMethod }) => ({
        url: `${ORDERS_URL}/${orderId}/payment-method`,
        method: 'PUT',
        body: { paymentMethod },
      }),
    }),
    getMyOrders: builder.query({
      query: () => ({
        url: `${ORDERS_URL}/mine`,
      }),
      keepUnusedDataFor: 5,
    }),
    getOrders: builder.query({
      query: () => ({
        url: ORDERS_URL,
      }),
      keepUnusedDataFor: 5,
    }),
    deliverOrder: builder.mutation({
      query: (orderId) => ({
        url: `${ORDERS_URL}/${orderId}/deliver`,
        method: "PUT",
      }),
    }),
  }),
});

export const { useCreateOrderMutation, useGetOrderDetailsQuery, useGetOrderInvoiceQuery, usePayOrderMutation, useUpdateOrderPaymentMethodMutation, useGetMyOrdersQuery, useGetOrdersQuery, useDeliverOrderMutation, useCompleteOrderPurchaseMutation  } = ordersApiSlice
